import React, { useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navbarListItems } from "../../data/navbarList";
import { LOGOUT } from "reducer/actions";
import { useDispatch, useSelector } from "react-redux";
import useWidowResize from "customHooks/useWidowResize";

const Navbar = () => {
  const { user } = useSelector((state) => state.user);
  const [navbarList, setNavbarList] = React.useState(navbarListItems);

  useEffect(() => {
    console.log("user", user);
    if (user?.userType === "ADMIN_ASSISTANT") {
      setNavbarList(navbarListItems.filter(item => item.role === "both" || item.role === "assistant"));
    }
    else {
      setNavbarList(navbarListItems.filter(item => item.role === "both" || item.role === "admin"));
    }

  }, [user])





  const [windowWidth] = useWidowResize();
  const location = useLocation();
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch({ type: LOGOUT });
  };
  const handleSideMenuLink = () => {
    if (windowWidth <= 992) {
      document.body.classList.toggle("sidebar-enable");
      document.body.classList.toggle("vertical-collpsed");
    }
  };
  return (
    <>
      <header id="page-topbar" className=" position-sticky top-0 shadow">
        <div className="navbar-header">
          <div className="d-flex">
            {/* LOGO */}
            <div className="navbar-brand-box">
              <a href="index.html" className="logo logo-dark">
                <span className="logo-lg">
                  <img src="assets/images/pyramid_1024.jpg" alt="" height={50} />
                </span>
              </a>
            </div>
          </div>
          <div className="d-flex">
            <nav className="navbar navbar-expand-lg p-0">
              <div
                className="collapse navbar-collapse d-flex justify-content-between align-items-center"
                id="navbarNav"
              >
                <ul className="navbar-nav">
                  {navbarList.map((navItem, i) =>
                    navItem.multi ? (
                      <li className="nav-item" key={i}>
                        <div className="dropdown d-inline-block">
                          <button
                            type="button"
                            className="btn header-item waves-effect"
                            id="page-header-user-dropdown"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            Menu Item
                            <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
                          </button>
                          <ul className="dropdown-menu">
                            {navItem.linkList.map((subItem, j) => (
                              <NavLink
                                className={({ isActive }) =>
                                  "nav-link" + (isActive ? " active" : "")
                                }
                                to={subItem.link}
                                key={j}
                              >
                                {subItem.title}
                              </NavLink>
                            ))}
                          </ul>
                        </div>
                      </li>
                    ) : (
                      <li className="nav-item" key={i}>
                        <NavLink
                          className={({ isActive }) =>
                            "nav-link" + (isActive ? " active" : "")
                          }
                          to={navItem.link}
                        >
                          {navItem.title}
                        </NavLink>
                      </li>
                    )
                  )}
                </ul>
              </div>
            </nav>
            <div className="dropdown d-inline-block">
              <button
                type="button"
                className="btn header-item waves-effect"
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img
                  className="rounded-circle header-profile-user"
                  src="assets/images/users/defaultUser.png"
                  alt="Header Avatar"
                />
                <span className="d-none d-xl-inline-block ms-1" key="t-henry">
                  {/* {user?.fullName} */}
                </span>
                <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
              </button>
              <div className="dropdown-menu dropdown-menu-end">
                <button
                  className="dropdown-item text-danger py-2"
                  onClick={handleLogout}
                >
                  <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
                  <span key="t-logout">Logout</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* <nav className="navbar navbar-expand-lg navbar-light bg-white shadow position-sticky top-0 z-1 ">
        <div className="container-fluid">
          <div
            className="collapse navbar-collapse d-flex justify-content-between align-items-center"
            id="navbarNav"
          >
            <ul className="navbar-nav">
              {navbarListItems.map((navItem, i) =>
                navItem.multi ? (
                  <li className="nav-item" key={i}>
                    <div className="dropdown">
                      <button
                        className="btn btn-secondary dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Menu Item
                      </button>
                      <ul className="dropdown-menu">
                        {navItem.linkList.map((subItem, j) => (
                          <NavLink
                            className={({ isActive }) =>
                              "nav-link" + (isActive ? " active" : "")
                            }
                            to={subItem.link}
                            key={j}
                          >
                            {subItem.title}
                          </NavLink>
                        ))}
                      </ul>
                    </div>
                  </li>
                ) : (
                  <li className="nav-item" key={i}>
                    <NavLink
                      className={({ isActive }) =>
                        "nav-link" + (isActive ? " active" : "")
                      }
                      to={navItem.link}
                    >
                      {navItem.title}
                    </NavLink>
                  </li>
                )
              )}
            </ul>
            <button onClick={handleLogout} className="btn btn-primary">
              Logout
            </button>
          </div>
        </div>
      </nav> */}
    </>
  );
};

export default Navbar;
